// ENG-050: host-context helpers shared by the chat request (Chat.tsx) and the mic usage ping
// (useSpeechInput.ts). The host sets window.PublicWidgetConfig.hostContext via
// ChatWidget.init / setHostContext, so it is always read at call time.

export const normalizeHostContextField = (value: unknown, maxLength = 256): string | undefined => {
    if (typeof value !== "string") return undefined;
    const normalized = value
        .replace(/[\u0000-\u001F\u007F]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    return normalized ? normalized.slice(0, maxLength) : undefined;
};

// The host's store as it is right now. Keys are present only when the host set a usable value.
// Limits match the gateway's HOST_CONTEXT_FIELD_LIMITS (storeId 256, storeName 500).
export const currentHostStore = (): { storeId?: string; storeName?: string } => {
    try {
        const hostContext = (window as any)?.PublicWidgetConfig?.hostContext;
        const storeId = normalizeHostContextField(hostContext?.storeId, 256);
        const storeName = normalizeHostContextField(hostContext?.storeName, 500);
        return { ...(storeId ? { storeId } : {}), ...(storeName ? { storeName } : {}) };
    } catch {
        return {};
    }
};
